import React from "react";
import { Outlet, useLocation, useNavigate, Navigate } from "react-router-dom";
import InnerBanner from "../components/inner_banner/InnerBanner";
import Sidebar from "../components/sidebar/Sidebar";
import "./Pages.css";

const LifeAtCampus = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menu = [
    { name: "Life @ MANET", path: "campus-life" },
    { name: "Conduct At Campus", path: "conduct-at-campus" },
    { name: "Accommodation", path: "accommodation" },
    { name: "National Maritime Day", path: "national-maritime-day" },
    { name: "Vishwanath Sport Campus", path: "vishwanath-sport " },
    { name: "MIT - Persona Fest", path: "mit-persona-fest" },
    { name: "Library", path: "library" },
    { name: "Sports", path: "sports" },
    { name: "Student Grievance", path: "student-grievance" },
    { name: "MANET Blogs", path: "manet-blogs" },
    { name: "Happenings", path: "happenings" },
    { name: "Gallery", path: "gallery" },
  ];

  const activeItem =
    menu.find((m) => location.pathname.includes(m.path))?.name ||
    "Life At Campus";

  // Mapping for title + background based on route
  const bannerDataMap = {
    "conduct-at-campus": {
      title: "Conduct At Campus",
      bgImage: "/assets/images/inner_bnr/DSC_2724.jpg",
    },
    accommodation: {
      title: "Accommodation",
      bgImage: "/assets/images/inner_bnr/Accomodatation.jpg",
    },
    "national-maritime-day": {
      title: "National Maritime Day",
      bgImage: "/assets/images/inner_bnr/National-Maritime.jpg",
    },
    "vishwanath-sport": {
      title: "Vishwanath Sport Campus",
      bgImage: "/assets/images/inner_bnr/Vishwanath_Sports_Meet.jpg",
    },

    "mit-persona-fest": {
      title: "MIT - Persona Fest",
      bgImage: "/assets/images/inner_bnr/Persona.jpg",
    },
    library: {
      title: "Library",
      bgImage: "/assets/images/inner_bnr/DSC_2597.jpg",
    },
    sports: {
      title: "Sports",
      bgImage: "/assets/images/inner_bnr/Sports.jpg",
    },
    "student-grievance": {
      title: "Top Recruiters",
      bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
    },
    "manet-blogs": {
      title: "MANET Blogs",
      bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
    },
    happenings: {
      title: "Happenings",
      bgImage: "/assets/images/inner_bnr/Happenings.jpg",
    },
    gallery: {
      title: "Gallery",
      bgImage: "/assets/images/inner_bnr/Gallery.jpg",
    },
  };

  //  Reusable function to fetch matching banner data
  const getBannerData = () => {
    const matchedKey = Object.keys(bannerDataMap).find((key) =>
      location.pathname.includes(key),
    );

    // If no match found → default to About MANET
    return (
      bannerDataMap[matchedKey] || {
        title: "LifeAtCampus",
        bgImage: "/assets/images/inner_bnr/DSC_1264.webp",
      }
    );
  };

  const { title, bgImage } = getBannerData();

  const subtitle = "Sailing Towards Excellence & a Brighter Future with MANET";

  console.log("welcome");
  return (
    <>
      <InnerBanner bgImage={bgImage} title={title} subtitle={subtitle} />

      <div className="page-layout">
        <Sidebar menuItems={menu} />

        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default LifeAtCampus;
